import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useStateSelector } from '../../../store/selectors';
import { paths } from '../../../routing/path';
import { AdminMarketplaceTab } from '../../../slices/marketplace/timeline/models/enums/admin-marketplace-tab.enum';
import './ViewAsBuyerHeaderContent.scss';

export const ViewAsBuyerHeaderContent = () => {
    const viewAsBuyer = useStateSelector((state) => state.viewAsBuyer);
    const navigate = useNavigate();

    const returnToAdmin = () => {
        navigate(
            `${paths.admin.marketplace}?tab=${AdminMarketplaceTab.MarketplaceBuyers}`
        );
    };

    return (
        <div className="view-as-buyer-header">
            <span className="view-as-buyer-header__message">
                {`Viewing as ${viewAsBuyer.buyerName} — read-only mode, actions are disabled.`}
            </span>
            <Button className="btn btn-primary" onClick={returnToAdmin}>
                Return to Admin
            </Button>
        </div>
    );
};
